import { css, cx } from "@emotion/css";

import { Text } from "../../../foundations/typography/Text";
import { Icon } from "../../../foundations/icons/Icon/Icon";

import { useColors } from "../../../hooks/useColors";
import { useGetAllFocusShadows } from "../../utils";
interface TagProps {
  id: string;
  textValue: string;
  isDisabled?: boolean;
  onRemove?: () => void;
}

export function _Tag(props: TagProps) {
  const { textValue, id, isDisabled, onRemove } = props;
  const colors = useColors();
  const getAllFocusShadows = useGetAllFocusShadows();

  return (
    <div
      className={cx(
        styles.tag,
        css({
          background: colors["background-accent-neutral-weak"],
          cursor: isDisabled ? "initial" : "pointer",
          "&:focus-within": getAllFocusShadows(),
        })
      )}
      id={id}
      data-testid={`${textValue}-tag`}
    >
      <Text style="global/label-small">{textValue}</Text>
      {!isDisabled && onRemove && (
        <button
          className={styles.removeButton}
          onClick={onRemove}
          aria-label={`Remove ${textValue}`}
        >
          <Icon type="mini" name="close" size="space-3" />
        </button>
      )}
    </div>
  );
}

const styles = {
  tag: css({
    height: "var(--space-5)",
    width: "fit-content",
    display: "flex",
    alignItems: "center",
    gap: "var(--space-1)",
    padding: "var(--space-05) var(--space-1)",
    borderRadius: "var(--border-radius-2)",
    outline: "none",
  }),
  removeButton: css({
    all: "unset",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      opacity: 0.8,
    },
  }),
};
